import { useState } from 'react';
import { api } from '@/lib/api';
import { logger } from '@/lib/logger';

/* Validates an email against the backend's /auth/validate-email endpoint,
 * exposing error + suggested-correction state. Shared by the account email
 * change form and (optionally) registration. Validation failures are
 * non-blocking (logged, not surfaced) so a flaky validator never blocks the user. */
export function useEmailValidation() {
  const [emailError, setEmailError] = useState('');
  const [emailSuggestion, setEmailSuggestion] = useState('');
  const [validating, setValidating] = useState(false);

  const clear = () => { setEmailError(''); setEmailSuggestion(''); };

  const validateEmail = async (email) => {
    if (!email || email.length < 5) { clear(); return; }
    setValidating(true);
    try {
      const { data } = await api.post('/auth/validate-email', { email });
      if (!data.valid) {
        setEmailError(data.error || '');
        setEmailSuggestion(data.suggestion || '');
      } else {
        clear();
      }
    } catch (err) {
      logger.warn('Email validation skipped:', err?.message || err);
    } finally {
      setValidating(false);
    }
  };

  return { emailError, emailSuggestion, validating, validateEmail, clear };
}
